export const dropdowns = {
  ACCOUNT_MAPPING_STATUS: 'account_mapping_status',
  ACCOUNT_MAPPING_REMAP: 'account_mapping_remap',
  EXPORT: 'export',
  OVERVIEW: 'overview',
  REVIEW_FILTER: 'review_filter',
  REVIEW_COMMS_FILTER: 'review_comms_filter',
  WORKFLOW_STATUS: 'workflow_status',
}
